import { render, staticRenderFns } from "./CourseRating.vue?vue&type=template&id=6f825783&scoped=true&"
import script from "./CourseRating.vue?vue&type=script&lang=js&"
export * from "./CourseRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f825783",
  null
  
)

export default component.exports